import { Component, inject, input } from '@angular/core';

import { FontIconComponent } from '@camelot/icons';
import { ENotificationCode, LAZY_SERVICE_TOKEN } from '@camelot/notification';
import { CamBaseComponent, copyTextToClipboard } from '@camelot/utils';

@Component({
  selector: 'cam-text-to-clipboard',
  templateUrl: './text-to-clipboard.component.html',
  styleUrls: ['./text-to-clipboard.component.scss'],
  imports: [FontIconComponent],
})
export class TextToClipboardComponent extends CamBaseComponent {
  value = input.required<string>();

  protected _notificationService = inject(LAZY_SERVICE_TOKEN);

  public copyContent = async () => {
    const successNotification = (message: string) => {
      this._notificationService.addNotification(message, ENotificationCode.success);
    };
    const errorNotification = (message: string) => {
      this._notificationService.addNotification(message, ENotificationCode.error);
    };

    await copyTextToClipboard(this.value(), successNotification, errorNotification);
  };
}
